import { z, zCalendarDate } from '@harvestiq/zod';
import { RmaLgmTypeCodes } from '@harvestiq/constants';
import {
  zDecimalNullable,
  zDecimalRequired,
  zCoercedBoolean,
} from '@harvestiq/zod';

// request
export const lgmIndemnityRequestSchema = z.object({
  coverages: z
    .array(
      z.object({
        typeCode: z.nativeEnum(RmaLgmTypeCodes),
        deductible: z.coerce.number().int(),
        salesEffectiveDate: zCalendarDate(),
        referenceId: z.string().optional(),
        marketings: z.array(
          z.object({
            marketingDate: zCalendarDate(),
            numberOfHead: z.coerce.number().min(0),
          })
        ),
        isPre2026BeginningFarmerRancher: zCoercedBoolean().optional(),
        isVeteranFarmerRancher: zCoercedBoolean().optional(),
        beginningFarmerRancherCropYearCount: z.coerce
          .number()
          .int()
          .nullable()
          .optional(),
        liveCattleTargetCwtPerHead: z.coerce.number().optional(),
        feederCattleTargetCwtPerHead: z.coerce.number().optional(),
        cornTargetBuPerHead: z.coerce.number().optional(),
      })
    )
    .min(1, 'At least one coverage is required')
    .max(250, 'Maximum 250 coverages allowed per request'),
});

export type LgmIndemnityRequest = z.infer<typeof lgmIndemnityRequestSchema>;

// response
export const lgmIndemnityResponseSchema = z.object({
  data: z.array(
    z.object({
      typeCode: z.nativeEnum(RmaLgmTypeCodes),
      deductible: z.number().int(),
      referenceId: z.string().optional(),
      salesEffectiveDate: zCalendarDate(),
      grossMarginGuaranteesPerHead: zDecimalRequired().array(),

      projectedGrossMarginsPerHead: zDecimalNullable().array(),
      projectedGrossMarginTotals: zDecimalNullable().array(),
      coverageProjectedGrossMarginTotal: zDecimalNullable(),

      actualGrossMarginsTotals: zDecimalNullable().array(),
      actualGrossMarginsPerHead: zDecimalNullable().array(),
      coverageActualGrossMarginTotal: zDecimalNullable(),

      coverageProjectedIndemnityPerHead: zDecimalRequired(),
      coverageProjectedIndemnityTotal: zDecimalRequired(),
      coverageActualIndemnityPerHead: zDecimalNullable(),
      coverageActualIndemnityTotal: zDecimalNullable(),
      marketings: z.array(
        z.object({
          marketingDate: zCalendarDate(),
          numberOfHead: z.number(),
        })
      ),
    })
  ),
});

export type LgmIndemnityResponse = z.infer<typeof lgmIndemnityResponseSchema>;
